firebird.factory('hostsAPIService', [
    '$q',
    '$resource',
    'helperService',
    'authService',
    function ($q, $resource, helperService, authService) {
        var endpoint = helperService.getAPIUrl() + '/host';

        var service = {
            getHostDetails: getHostDetails,
            getUpcomingMeetings: getUpcomingMeetings,
            getPastcomingMeetings: getPastcomingMeetings,
            getActiveMeeting: getActiveMeeting,
            startScheduledMeeting: startScheduledMeeting,
            startQuickMeeting: startQuickMeeting
        };

        return service;

        ////////////////////////

        function getHostDetails(params) {
            var deferred = $q.defer();

            var paramDefaults = {
                meetingAccessCode: '@meetingAccessCode'
            };

            $resource(endpoint, paramDefaults)
                .get(params)
                .$promise.then(
                    function (hostDetails) {
                        var host = {
                            fullname: hostDetails.name,
                            email: hostDetails.email,
                            isHost: true,
                            analyticsUserKey: hostDetails.analyticsUserKey,
                            createdAtUnixTime: hostDetails.createdAtUnixTime,
                            shortcutURL: hostDetails.shortcutURL,
                            imageURL: hostDetails.imageURL,
                            presenterPIN: hostDetails.presenterPIN,
                            attendeePIN: hostDetails.attendeePIN,
                            numberToll: hostDetails.numberToll,
                            extended: hostDetails.extended,
                            notificationCulture: hostDetails.notificationCulture
                        };

                        deferred.resolve(host);
                    },
                    function (err) {
                        deferred.reject(err.status + ' - Could not retrieve host details.');
                    }
                );

            return deferred.promise;
        }

        function getUpcomingMeetings() {
            var deferred = $q.defer();

            const authToken = authService.getAuthToken();

            var actions = {
                get: {
                    method: 'GET',
                    isArray: true,
                    headers: { Authorization: 'Bearer ' + authToken }
                }
            };

            $resource(endpoint + '/meetings/upcoming', {}, actions)
                .get()
                .$promise.then(
                    function (upcomingMeetings) {
                        deferred.resolve(upcomingMeetings);
                    },
                    function (err) {
                        deferred.reject(err.status + ' - Could not retrieve upcoming meetings.');
                    }
                );

            return deferred.promise;
        }

        function getPastcomingMeetings() {
            var deferred = $q.defer();

            $resource(endpoint + '/meetings/past')
                .query()
                .$promise.then(
                    function (pastMeetings) {
                        deferred.resolve(pastMeetings);
                    },
                    function (err) {
                        deferred.reject(err.status + ' - Could not retrieve past meetings.');
                    }
                );

            return deferred.promise;
        }

        function getActiveMeeting() {
            var deferred = $q.defer();

            const authToken = authService.getAuthToken();

            var actions = {
                get: {
                    method: 'GET',
                    headers: { Authorization: 'Bearer ' + authToken }
                }
            };

            $resource(endpoint + '/meetings/active', {}, actions)
                .get()
                .$promise.then(
                    function (activeMeeting) {
                        deferred.resolve(activeMeeting);
                    },
                    function (err) {
                        deferred.reject(err.status + ' - Could not retrieve active meetings.');
                    }
                );

            return deferred.promise;
        }

        function startScheduledMeeting(param) {
            var deferred = $q.defer();

            const authToken = authService.getAuthToken();

            var actions = {
                post: {
                    method: 'POST',
                    headers: { Authorization: 'Bearer ' + authToken }
                }
            };

            var paramDefaults = {
                meetingAccessCode: '@meetingAccessCode'
            };
            $resource(endpoint + '/meetings/:meetingAccessCode', paramDefaults, actions)
                .post(param)
                .$promise.then(
                    function (meeting) {
                        deferred.resolve(meeting);
                    },
                    function (err) {
                        if (err.status == 302 && err.data) {
                            deferred.resolve(err.data.data);
                        }
                        deferred.reject(err.status + ' - Could not start scheduled meeting.');
                    }
                );

            return deferred.promise;
        }

        function startQuickMeeting() {
            var deferred = $q.defer();

            const authToken = authService.getAuthToken();

            var actions = {
                post: {
                    method: 'POST',
                    headers: { Authorization: 'Bearer ' + authToken }
                }
            };

            $resource(endpoint + '/meetings/', {}, actions)
                .post()
                .$promise.then(
                    function (meeting) {
                        deferred.resolve(meeting.data);
                    },
                    function (err) {
                        if (err.status == 302 && err.data) {
                            deferred.resolve(err.data.data);
                        }
                        deferred.reject(err.status + ' - Could not quick start meeting.');
                    }
                );

            return deferred.promise;
        }
    }
]);
